export default __webpack_public_path__ + "static/media/metamask.830735e3.svg";